import * as React from "react";
import { useState } from "react";
import useProductName from "brand-customization/useProductName";
import createDocumentTitleRegistry from "contexts/createDocumentTitleRegistry";
import DocumentTitleContext from "./DocumentTitleContext";
const DocumentTitleContextProvider = ({ children }) => {
  const productName = useProductName();
  const [registry] = useState(() => createDocumentTitleRegistry(productName));
  return /* @__PURE__ */ React.createElement(DocumentTitleContext.Provider, { value: registry }, children);
};
export default DocumentTitleContextProvider;
